class BxfCalendarSettingsConstants {
    static STRING = {
        DEFAULT_DAY: 15,
        DEFAULT_MONTH: 0,
    };
}

export { BxfCalendarSettingsConstants as B };
